module.exports = __webpack_public_path__ + "static/media/screen3.251ec358.png";